import type React from 'react';
import { ConfirmationDialogV2, type ConfirmationDialogV2Props } from '@/components/custom/erp';

type LegacyConfirmDialogProps = ConfirmationDialogV2Props & {
  onCloseConfirmDialog?: () => void;
  content?: React.ReactNode;
  message?: React.ReactNode;
  selectedObj?: MuaHangRecord | null;
  deleteGroup?: (uuid: string) => Promise<MuaHangRecord>;
  deleteKhuVuc?: (uuid: string) => Promise<MuaHangRecord>;
  deleteDoiTuong?: (uuid: string) => Promise<MuaHangRecord>;
  clearSelection?: () => void;
  confirmText?: string;
  showCancel?: boolean;
  isLoading?: boolean;
};

export const ConfirmDialog = ({
  onClose,
  onCloseConfirmDialog,
  onConfirm,
  onDelete,
  deleteGroup,
  deleteKhuVuc,
  deleteDoiTuong,
  clearSelection,
  selectedObj,
  content,
  message,
  title,
  confirmText,
  confirmButtonText,
  showCancel,
  showCancelBtn,
  isLoading,
  disableBackdropClose,
  disableEscapeKeyDown,
  ...props
}: LegacyConfirmDialogProps) => {
  const legacyDelete = onDelete ?? deleteGroup ?? deleteKhuVuc ?? deleteDoiTuong;
  const closeHandler = onCloseConfirmDialog ?? onClose ?? (() => {});
  const confirmHandler = async () => {
    if (legacyDelete && selectedObj?.uuid) {
      await legacyDelete(selectedObj.uuid);
      clearSelection?.();
      closeHandler();
      return;
    }

    if (onConfirm) {
      await onConfirm();
      return;
    }

    if (onCloseConfirmDialog && onClose) {
      onClose();
    }
  };

  return (
    <ConfirmationDialogV2
      {...props}
      selectedObj={selectedObj}
      onClose={closeHandler}
      onConfirm={() => void confirmHandler()}
      title={title}
      message={message ?? content}
      confirmButtonText={confirmText ?? confirmButtonText}
      showCancelBtn={showCancel ?? showCancelBtn}
      disableBackdropClose={isLoading || disableBackdropClose}
      disableEscapeKeyDown={isLoading || disableEscapeKeyDown}
    />
  );
};

export default ConfirmDialog;
